import * as Sentry from "@sentry/react";

const initSentry = (dsn: string, environment: string, apiUrl: string) => {
  if (!dsn) {
    console.warn("Sentry is not enabled! DSN is missing!");
  }

  if (!apiUrl) {
    console.warn(
      "Recordings might not show API request payload. API URL is missing!"
    );
  }

  Sentry.init({
    dsn,
    environment,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        // form values (2FA codes, personal data) stay out of the recording
        maskAllInputs: true,
        blockAllMedia: false,
        // record that an API call happened (url, status, timing) but never its
        // body: GraphQL payloads carry passwords, auth tokens and integration
        // secrets, and the replay library captures bodies by default
        networkDetailAllowUrls: apiUrl ? [apiUrl] : undefined,
        networkCaptureBodies: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
};

export default initSentry;
